import * as e from "react";
const a = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "RW_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#RW_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#FECA00"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "RW_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#RW_svg__b)", fillRule: "evenodd", clipRule: "evenodd" }, /* @__PURE__ */ e.createElement("path", { d: "M0 0v14h32V0H0z", fill: "#3CA5D9" }), /* @__PURE__ */ e.createElement("path", { d: "M0 18v6h32v-6H0z", fill: "#5A962A" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M24.082 11.866a4.155 4.155 0 01-.186 0l-.604 1.974-.128-2.056a3.913 3.913 0 01-.182-.042l-1.047 1.78.355-2.027a3.953 3.953 0 01-.17-.083l-1.43 1.49.816-1.888a3.836 3.836 0 01-.147-.12l-1.738 1.122 1.233-1.648c-.04-.05-.079-.101-.116-.153l-1.95.695 1.58-1.32a3.93 3.93 0 01-.077-.177l-2.055.23 1.843-.922a3.775 3.775 0 01-.034-.192l-2.05-.244 2.007-.477a4.04 4.04 0 01.01-.195l-1.937-.705 2.063-.006a3.84 3.84 0 01.057-.188l-1.72-1.127 2.01.464c.03-.057.064-.113.098-.169l-1.41-1.49 1.847.912c.044-.049.09-.096.136-.142L20.129 3.39l1.587 1.308c.054-.037.108-.072.164-.106l-.586-1.96 1.24 1.636c.06-.023.122-.045.184-.066l-.114-2.042.826 1.877c.064-.008.128-.016.193-.021L23.989 2l.366 2.017c.065.006.129.013.192.022l.827-1.879-.114 2.047c.061.02.121.042.18.065l1.244-1.64-.588 1.967c.054.034.107.069.16.105l1.593-1.314-1.032 1.781c.044.045.088.09.13.138l1.859-.916-1.42 1.498c.033.054.064.108.095.163l2.022-.467-1.732 1.135c.02.06.038.12.054.18l2.078.006-1.952.71c.005.062.008.124.01.186l2.023.481-2.066.246c-.01.061-.02.122-.033.183l1.857.93-2.069-.233a3.785 3.785 0 01-.074.17l1.59 1.329-1.96-.699c-.036.05-.073.099-.112.147l1.24 1.658-1.747-1.128c-.046.04-.093.08-.141.117l.82 1.898-1.437-1.497c-.054.03-.109.056-.165.083l.356 2.033-1.049-1.784c-.06.016-.12.03-.18.043l-.128 2.059-.604-1.974zm-.136-1.45c1.4 0 2.536-1.12 2.536-2.5s-1.136-2.499-2.536-2.499c-1.4 0-2.536 1.119-2.536 2.5 0 1.38 1.135 2.498 2.536 2.498zm1.459-2.427a1.43 1.43 0 11-2.858 0 1.43 1.43 0 012.858 0z",
      fill: "#FFDC17"
    }
  )))
), t = a;
export {
  t as default
};
